<template>
  <tr>
    <td>
      <player-link :playerId="member.player_id" lable="" />
    </td>
    <td>{{playerName}}</td>
    <td>{{leaderStr}}</td>
    <td class="text-right">
      {{member.level}}
    </td>
    <td>
      {{member.ctime | getMomentStr}}
    </td>
    <td class="text-right" :class="membershipDurationDaysClass">
      {{membershipDurationDays}}
    </td>
    <td class="text-right" :class="weekHelpClass">
      {{member.week_help}}
    </td>
    <td class="text-right" :class="activityRatingClass">
      {{activityRating}}
    </td>
  </tr>
</template>

<script>
import { getPlayerName } from '../../model/player.js';

import { calcMemberMembershipDurationDays } from '../../model/club.js';
import { calcMemberActivityRating         } from '../../model/club.js';

import PlayerLink from '../PlayerLink.vue';

export default {
  name: 'Member',

  components: {
    PlayerLink,
  },

  props: {
    member: {
      type: Object,
      required: true,
    },

    isLeader: {
      type: Boolean,
      default: false,
    },

    now: {
      type: Number,
      required: true,
    },
  },

  computed: {
    /** @returns {string} */
    playerName() {
      return getPlayerName(this.member);
    },

    /** @returns {string} */
    leaderStr() {
      if(this.isLeader) {
        return 'leader';
      }

      return '';
    },

    /** @returns {number} */
    membershipDurationDays() {
      return calcMemberMembershipDurationDays(this.member.ctime, this.now);
    },

    /** @returns {Object} */
    membershipDurationDaysClass() {
      return {
        muted: this.membershipDurationDays === 0,
      };
    },

    /** @returns {Object} */
    weekHelpClass() {
      return {
        muted: this.member.week_help === 0,
      };
    },

    /** @returns {number} */
    activityRating() {
      return calcMemberActivityRating(this.member.ctime, this.now, this.member.week_help);
    },

    /** @returns {Object} */
    activityRatingClass() {
      return {
        muted: this.activityRating === 0,
      };
    },
  },

  methods: {
  },
};
</script>

<style scoped>
.muted {
  color: #dedede;
}
</style>
